var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDirgahayuBannerRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 69,
    viewBox: "0 0 125 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 8H55.5",
    stroke: "#DDD7D7",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65 1H93",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68 8H96",
    stroke: "#DDD7D7",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M111.386 27.9236C111.386 27.9236 113.141 26.3991 115.774 26.0856C118.406 25.772 120.161 26.5451 120.161 26.5451",
    stroke: "#9D1516",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M117.09 23.3286C117.09 23.3286 114.656 21.5045 112.702 20.5715C110.385 19.4646 107.437 20.112 107.437 20.112",
    stroke: "#9D1516",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0885 59.1709C24.5722 58.2018 18.8026 55.0353 18.8026 55.0353C18.8026 55.0353 14.3748 53.3448 10.027 49.9806C9.42835 49.5174 8.85239 49.0383 8.30238 48.5538L27.3024 48.5538C34.7616 48.5538 43.822 44.511 52.8024 39.9158C60.3024 36.0782 62.4985 35.1171 73.6504 29.3024C84.8024 23.4878 94.3023 20.4158 102.65 19.3196C110.964 18.2278 112.956 19.5315 116.606 21.9208L116.651 21.9502C120.161 24.2478 123.856 28.3871 123.856 28.3871C123.856 28.3871 119.656 26.1249 115.6 27.0912C111.543 28.0574 108.585 31.4604 108.585 31.4604C108.585 31.4604 113.117 31.6038 117.331 38.4927C119.74 42.4293 121.039 45.3855 121.039 45.3855C121.039 45.3855 117.765 42.2063 113.58 41.2498C106.451 39.6209 98.3916 39.7 92.5181 41.2498C79.8676 44.588 68.7919 51.6993 56.0992 55.4948C45.8556 58.558 44.3271 61.1399 31.0885 59.1709Z",
    fill: "#FE0003"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8026 55.0353C18.8026 55.0353 24.5722 58.2018 31.0885 59.1709C44.3271 61.1399 45.8556 58.558 56.0992 55.4948C68.7919 51.6993 79.8676 44.588 92.5181 41.2498C98.3916 39.7 106.451 39.6208 113.58 41.2498C117.765 42.2063 121.039 45.3855 121.039 45.3855C121.039 45.3855 119.74 42.4293 117.331 38.4927C113.117 31.6038 108.585 31.4604 108.585 31.4604C108.585 31.4604 111.543 28.0574 115.6 27.0912C119.656 26.1249 123.856 28.3871 123.856 28.3871C123.856 28.3871 120.161 24.2478 116.651 21.9502C112.972 19.5422 110.998 18.2233 102.65 19.3196C94.3023 20.4158 84.8024 23.4878 73.6504 29.3024C62.4985 35.1171 60.3024 36.0782 52.8024 39.9158C43.822 44.511 34.7616 48.5538 27.3024 48.5538L8.30238 48.5538C8.85239 49.0383 9.42835 49.5174 10.027 49.9806M18.8026 55.0353C18.8026 55.0353 14.3748 53.3449 10.027 49.9806M18.8026 55.0353C18.8026 55.0353 13.4541 52.573 10.027 49.9806",
    stroke: "#FE0003",
    strokeWidth: 0.3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3022 38.916L64.3022 35.416",
    stroke: "#CD0204",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8024 44.416C92.3441 45.629 86.8024 47.916 86.8024 47.916H74.3024L93.8024 37.916L114.302 38.916L110.802 43.416C110.802 43.416 103.802 43.0827 97.8024 44.416Z",
    fill: "#DDD7D7",
    stroke: "#DDD7D7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8022 48.6021C45.4544 51.3349 38.9754 52.8843 31.8022 53.4158C21.8022 54.1568 14.234 51.9158 9.30225 48.6021H2.30225C5.37372 51.3592 11.0626 55.2195 14.3022 56.9158C18.1218 58.9158 21.3022 59.9158 27.3022 61.0091C30.163 61.5303 36.8022 61.9158 42.0581 61.0091C49.8544 59.664 57.2868 57.22 67.0687 53.6568C78.477 49.5012 86.5214 45.3855 96.0283 43.088C102.715 41.4719 109.732 41.0795 113.58 42.1689C117.427 43.2583 122.794 47.6831 122.794 47.6831C122.794 47.6831 120.939 41.1033 118.845 38.0333C114.457 31.6001 109.192 31.1406 109.192 31.1406C109.192 31.1406 98.3365 30.5461 78.477 38.0333C67.5074 42.1689 62.2118 45.1027 52.8022 48.6021Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.3
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3022 49.416C31.3022 49.416 38.7096 47.67 42.8022 45.916C49.8022 42.916 55.3022 39.916 55.3022 39.916",
    stroke: "#CD0204",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3022 59.916C24.3022 59.916 30.989 60.9646 35.3022 60.916C40.8247 60.8538 43.9255 60.1781 49.3022 58.916C52.6707 58.1253 58.3022 55.916 58.3022 55.916",
    stroke: "#DFDADA",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8022 52.416L73.8022 49.916",
    stroke: "#DFDADA",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M112.302 33.416C112.302 33.416 114.038 33.6522 116.302 35.916C118.802 38.416 119.302 40.416 119.302 40.416",
    stroke: "#DFDADA",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3022 42.4159C94.3022 42.4159 100.335 40.7609 104.302 40.4159C107.415 40.1453 109.283 40.114 112.302 40.9159C114.161 41.4095 116.302 42.4159 116.302 42.4159",
    stroke: "#DFDADA",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M2.30225 52.416C2.30225 52.416 5.80225 55.916 9.80225 58.416C13.8022 60.916 17.838 62.7861 21.3022 63.416C26.8022 64.416 33.8022 64.416 33.8022 64.416",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3022 61.916L55.3022 60.916",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8022 53.416L83.3022 49.916",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M113.302 44.916C113.302 44.916 114.802 44.916 117.302 46.416C119.802 47.916 120.302 48.416 120.302 48.416",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M116.302 28.4159C116.302 28.4159 117.466 28.0822 119.802 28.4159C121.025 28.5905 122.802 29.4159 122.802 29.4159",
    stroke: "#FF0003",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3022 48.416H9.30225C9.30225 48.416 12.5209 50.1913 14.3022 50.916C15.8476 51.5447 18.8022 52.416 18.8022 52.416C18.8022 52.416 19.7507 50.9675 20.8022 49.916C22.2264 48.4918 24.3022 48.416 24.3022 48.416Z",
    fill: "#CD0204"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3022 56.416C18.0144 53.5673 18.8022 52.416 18.8022 52.416C18.8022 52.416 15.5007 51.6555 13.8022 50.916C11.959 50.1135 9.30225 48.416 9.30225 48.416H1.80225C1.80225 48.416 6.57448 52.1595 8.30225 53.416C13.8022 57.416 17.3022 58.416 17.3022 58.416C17.3022 58.416 16.9571 57.7964 17.3022 56.416Z",
    fill: "#F5F3F3"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M102 1C102 1 105.735 1 109 3C112 4.83757 114 7.5 114 7.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M102.041 8.56249C102.041 8.56249 105.361 8.72556 108 11.5001C110.425 14.0493 110.5 16.0001 110.5 16.0001",
    stroke: "#DDD7D7",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirgahayuBannerRight);
export default __webpack_public_path__ + "static/media/dirgahayu_banner_right.62d728728b0280ed98c44460ac8b1d93.svg";
export { ForwardRef as ReactComponent };